//
//
//
//
//
//
//

export default {
  name: 'SingleLoading',
  props: {
    isWhite: {
      type: Boolean,
      default: false
    }
  }
}
